import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Select,
  MenuItem,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import { addStringToMPPT } from "../../../../store/slices/pva_testReport.slices";
import StringAccordion from "./strAcc";

const MPPTAccordion = ({ mppt, inverterIndex, mpptIndex }) => {
  const dispatch = useDispatch();
  const { invertersList } = useSelector((state) => state.pva_test);

  const inverter = invertersList[inverterIndex];
  const totalStrings = inverter.noOfStrings;
  const totalMppts = inverter.noOfMppt;

  // 🧮 Max strings per MPPT
  const stringsPerMppt = Math.floor(totalStrings / totalMppts);

  // 🟠 Determine used string IDs across this inverter (not just this MPPT)
  const usedStringIds = inverter.mppts
    .flatMap((m) => m.strings.map((s) => s.id))
    .filter(Boolean);

  // 🟢 All available strings (e.g. String 1 → String N)
  const availableStringOptions = Array.from(
    { length: totalStrings },
    (_, i) => `String ${i + 1}`
  );

  const handleSelect = (event) => {
    const value = event.target.value;
    if (value && !usedStringIds.includes(value)) {
      dispatch(addStringToMPPT({ inverterIndex, mpptIndex, stringId: value }));
    }
  };

  return (
    <Accordion>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pr: 1,
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>{mppt.name}</Typography>
        </AccordionSummary>
      </Box>
      <AccordionDetails>
        {/* 🔹 Dropdown to select which string to add */}
        <Box sx={{ mb: 2 }}>
          <Select
            size="small"
            displayEmpty
            value=""
            onChange={handleSelect}
            disabled={mppt.strings.length >= stringsPerMppt}
            sx={{ width: 200 }}
          >
            <MenuItem value="">
              {mppt.strings.length >= stringsPerMppt
                ? "String Limit Reached"
                : "Select String"}
            </MenuItem>

            {availableStringOptions.map((stringId) => (
              <MenuItem
                key={stringId}
                value={stringId}
                disabled={usedStringIds.includes(stringId)} // 🔒 Disable already-used strings
                sx={{
                  opacity: usedStringIds.includes(stringId) ? 0.5 : 1,
                  fontStyle: usedStringIds.includes(stringId)
                    ? "italic"
                    : "normal",
                }}
              >
                {stringId}
                {usedStringIds.includes(stringId) && " (Added)"}
              </MenuItem>
            ))}
          </Select>
        </Box>

        {mppt.strings.length > 0 ? (
          mppt.strings.map((str, strIndex) => (
            <StringAccordion
              key={strIndex}
              str={str}
              inverterIndex={inverterIndex}
              mpptIndex={mpptIndex}
              stringIndex={strIndex}
            />
          ))
        ) : (
          <Typography variant="body2" color="text.secondary">
            No Strings Added Yet
          </Typography>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default MPPTAccordion;
